<template>
    <v-form :name="searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList>
                <Tab value="0">{{ __('Search condition') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormMultiselect fieldName="provider_id"
                                         label="Provider"
                                         size="4"
                                         :options="select?.providers"
                                         :filter="(event) => onFilter(event, 'providers')"
                                         v-model:field="search.provider_id" />

                        <FormMultiselect fieldName="category_id"
                                         label="Category"
                                         size="4"
                                         :options="select?.categories"
                                         :filter="(event) => onFilter(event, 'categories')"
                                         v-model:field="search.category_id" />

                        <FormMultiselect fieldName="type_id"
                                         label="Type"
                                         size="4"
                                         :options="select?.types"
                                         :filter="(event) => onFilter(event, 'types')"
                                         v-model:field="search.type_id" />

                        <FormInputText fieldName="service_name"
                                       label="Service name"
                                       size="10"
                                       :isFocus="true"
                                       v-model:field="search.service_name" />

                        <FormInputText fieldName="symbol"
                                       label="Symbol"
                                       size="2"
                                       v-model:field="search.symbol" />

                        <FormInputText fieldName="lead_technology"
                                       label="Lead technology"
                                       size="12"
                                       v-model:field="search.lead_technology" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>


        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { onFilterService } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})

const autoSearch = ref(false)
const isLoading = ref(true);
const options = ["providers", "categories", "types"];
const select = ref(null);


let search = ref({})
prepareSearch(search, props, options, select)

// -----------------------------------------------------

const onFilter = async (event, option) => {
    await onFilterService(event, option, select, isLoading, search, null);
}

// -----------------------------------------------------
</script>

<style lang="scss" scoped></style>
